import React, { useRef } from "react";
import { SPEAKERS_ENGLISH, SPEAKERS_FRENCH } from "./utils/constants";

// Images and Icons
import SpeakerBgOverlay from "assets/breakfast-event/png-jpg/speaker-bg-overlay.png";
import TopicImage from "assets/breakfast-event/svgs/topic-img.svg";
import SpeakerIcon from "assets/breakfast-event/svgs/color-speaker.svg";
import AnchorRightIcon from "assets/breakfast-event/svgs/anchor-right.svg";
import CallForSpeakersImage from "assets/breakfast-event/png-jpg/call-for-speakers.png";
import CallForSpeakersLineImage from "assets/breakfast-event/png-jpg/call-for-speakers-line.png";

import Pagination from "./components/Pagination";

// Translations
import { useTranslation } from "react-i18next";

const Speakers = () => {
  // Translations
  const { t } = useTranslation("event");
  const language = localStorage.getItem("selectedLanguage");

  const containerRef = useRef(null);

  const SPEAKERS = language?.includes("fr")
    ? SPEAKERS_FRENCH
    : SPEAKERS_ENGLISH;

  // Functions
  const handleRegister = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSenje-uKU6rVjp7ERyQjAU11eIum7JCHm_jip4N46_Lserf8w/viewform",
      "_blank",
    );
  };

  return (
    <div
      id="speakers"
      className=" scroll-mt-[90px] bg-[#0F142D] font-euclid h-full"
    >
      <div className="py-[5rem] flex justify-center items-center flex-col">
        <div className="w-[92%] flex justify-center items-center flex-col text-white gap-5 mb-8">
          <div className="bg-[#FFC87F33] bg-opacity-20 rounded-full px-3 py-1 w-fit">
            <p className="text-base  font-euclidMedium text-center">
              {t("speakers.tag")}
            </p>
          </div>
          <h1 className="text-3xl md:text-[48px]  font-euclidSemibold text-center">
            {t("speakers.title")}
          </h1>
          <p className="text-base md:text-lg  font-euclidRegular text-center w-full md:w-[78%]">
            {t("speakers.description")}
          </p>
        </div>
        <div className="w-[92%] relative mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {SPEAKERS.map((speaker, index) => (
              <div
                key={index}
                className="group relative text-white w-full md:max-w-[330px] mx-auto"
              >
                {/* Speaker Image */}
                {/* <img
                  src={speaker.image}
                  alt={`speaker ${index + 1}`}
                  className="w-full h-[350px] md:h-[359px] rounded-xl shadow-md object-cover"
                /> */}
                <img
                  src={speaker.image}
                  alt={`speaker ${index + 1}`}
                  className="w-full h-[350px] md:h-[359px] rounded-xl shadow-md object-cover object-top grayscale-light"
                />

                {/* Speaker Info */}
                <div className="flex justify-center items-center flex-col mt-5">
                  <h1 className="text-center text-[20px] font-euclidSemibold">
                    {speaker.name}
                  </h1>
                  <p className="text-base text-center font-euclidItalic w-full">
                    {speaker.description}
                  </p>
                </div>

                {/* Hover Overlay */}
                <div
                  className="
          absolute bottom-[25%] left-0 right-0
      bg-cover bg-center
      p-8
      opacity-0
      translate-y-6
      group-hover:opacity-100
      group-hover:translate-y-0
      transition-all duration-500 ease-out
      flex flex-col justify-end items-center
          "
                  style={{ backgroundImage: `url(${SpeakerBgOverlay})` }}
                >
                  <img src={TopicImage} alt="TopicImage" />
                  <h4 className="text-[18px] text-[#1C295A] font-euclidSemibold mt-2 text-center">
                    {speaker.topic}
                  </h4>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center items-center flex-col mt-[3rem]">
          <div className="w-[92%] flex !justify-between items-center flex-col xl:flex-row text-white gap-10 md:gap-5">
            <div className="space-y-5 w-full xl:w-[65%]">
              <div className="flex items-center gap-5">
                <h4 className="text-[24px] font-euclidSemibold uppercase">
                  {t("speakers.callForSpeakers")}
                </h4>
                <img
                  src={SpeakerIcon}
                  alt="SpeakerIcon"
                  className="w-[24px] h-[24px]"
                />
                <img
                  src={CallForSpeakersLineImage}
                  alt="CallForSpeakersLineImage"
                  className="hidden md:block w-md:[383px] h-[10px]"
                />
              </div>
              <p className="text-lg font-euclidRegular">
                {t("speakers.callForSpeakersDescription")}
              </p>
              <div className="flex items-center">
                <button
                  className="bg-[#202D66] font-euclid text-white text-base xl:text-base font-semibold h-[48px] px-6 md:px-5 rounded-l-[16px] rounded-r-none"
                  onClick={handleRegister}
                >
                  {t("homeSection.cta")}
                </button>
                <button className="bg-[#AFF7CD] text-white text-base font-euclidSemibold h-[48px] px-5 rounded-r-[16px] rounded-l-none flex items-center justify-center">
                  <img src={AnchorRightIcon} alt="AnchorRightIcon" />
                </button>
              </div>
            </div>
            <img
              src={CallForSpeakersImage}
              alt="CallForSpeakersImage"
              className="w-[300px] h-[360px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Speakers;
